var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "550px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Search Config")]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "mb-2", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "mx-1 mt-0",
                        attrs: { label: "Major search", "hide-details": "" },
                        model: {
                          value: _vm.model.major,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "major", $$v)
                          },
                          expression: "model.major",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "mx-1 mt-0",
                        attrs: { label: "Minor search", "hide-details": "" },
                        model: {
                          value: _vm.model.minor,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "minor", $$v)
                          },
                          expression: "model.minor",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "mx-1 mt-0",
                        attrs: { label: "Skip Locked", "hide-details": "" },
                        model: {
                          value: _vm.model.skipLocked,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "skipLocked", $$v)
                          },
                          expression: "model.skipLocked",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "12", md: "12" } },
                    [
                      _c("r-item-table", {
                        attrs: { items: _vm.model.sources, title: "Sources" },
                        on: {
                          "update:items": function ($event) {
                            return _vm.$set(_vm.model, "sources", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }